"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * E-Verify Account Service
 * API for management of E-Verify Accounts
 *
 * The version of the OpenAPI document: 1.0.133
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.TerminationResultTypeToJSON = exports.TerminationResultTypeFromJSONTyped = exports.TerminationResultTypeFromJSON = exports.TerminationResultType = void 0;
/**
 * shows whether account termination passed or failed
 * @export
 * @enum {string}
 */
var TerminationResultType;
(function (TerminationResultType) {
    TerminationResultType["SUCCESS"] = "SUCCESS";
    TerminationResultType["FAIL"] = "FAIL";
})(TerminationResultType = exports.TerminationResultType || (exports.TerminationResultType = {}));
function TerminationResultTypeFromJSON(json) {
    return TerminationResultTypeFromJSONTyped(json, false);
}
exports.TerminationResultTypeFromJSON = TerminationResultTypeFromJSON;
function TerminationResultTypeFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
exports.TerminationResultTypeFromJSONTyped = TerminationResultTypeFromJSONTyped;
function TerminationResultTypeToJSON(value) {
    return value;
}
exports.TerminationResultTypeToJSON = TerminationResultTypeToJSON;
